'use client';

import { hasRolePlayer, useAuth } from '@svenskaspelab/nova-core/nextjs/auth';

type LoginBoundaryProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

// Not for visual components. Causes page jumps.
export default function LoginBoundary({ children, fallback = null }: LoginBoundaryProps) {
  const { user, isLoading: isAuthLoading } = useAuth();
  const isPlayer = hasRolePlayer(user);

  if (isAuthLoading || !isPlayer) {
    return fallback;
  }
  return children;
}
